import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Countdown({ seconds, src }) {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const navigate = useNavigate();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((t) => (t > 0 ? t - 1 : 0));
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      navigate(src);
    }
  }, [timeLeft]);

  return <>{timeLeft}s</>;
}
